import Vue from "vue";
import Router from "vue-router";
const index = () =>
    import ("../view/index.vue");
const contactus = () =>
    import ("../view/contactus.vue");
const about = () =>
    import ("../view/about.vue");
const achievement = () =>
    import ("../view/achievement.vue");
const product = () =>
    import ("../view/product.vue");
const det = () =>
    import ("../view/det.vue");
const partner = () =>
    import ("../view/partner.vue");

Vue.use(Router);

export default new Router({
    routes: [{
            path: "/",
            name: "index",
            component: index
        },
        {
            path: "/contactus",
            name: "contactus",
            component: contactus
        },
        {
            path: "/about",
            name: "about",
            component: about
        },
        {
            path: "/achievement",
            name: "achievement",
            component: achievement
        },
        {
            path: "/product",
            name: "product",
            component: product
        },
        {
            path: "/det",
            name: "det",
            component: det
        },
        {
            path: "/partner",
            name: "partner",
            component: partner
        }
    ]
});


// WEBPACK FOOTER //
// ./src/router/index.js